import { IEnterprise } from '../user-list/models/hierarchy.model'

export class HierarchyBase {
    
    segmentValues = []
    
    public getTotalMerchants(enterprise: IEnterprise): number {
        return enterprise?.merchants.length || 0
    }
    
    public getTotalProgramGroups(enterprise: IEnterprise): number {
        return enterprise?.programGroups.length || 0
    }
    
    public getSelectedMerchants(enterprise: IEnterprise): number {
        return enterprise?.merchants.filter(m => m.isSelected).length || 0
    }
    
    public getSelectedProgramGroups(enterprise: IEnterprise): number {
        return enterprise?.programGroups.filter(m => m.isSelected).length || 0
    }
    
    public segmentChanged(ev: Event, index: number): void {
        const customEvent = ev as CustomEvent
        this.segmentValues[index] = customEvent.detail.value as string
    }
}